import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2024 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect } from "react";
import { useListContext } from "react-admin";
export var ResetFilters = function (_a) {
    var setFilters = useListContext().setFilters;
    useEffect(function () {
        var resetFilters = function () {
            // Reset filters when the component mounts
            if (setFilters) {
                setFilters({}, {});
            }
        };
        resetFilters();
    }, []);
    return _jsx(_Fragment, {});
};
